<div class="nav-profile">
  <button class="nav-profile__icon">{{ initial }}</button>
  <div class="nav-profile__caret">
    <fa-icon [icon]="faCaretRight"></fa-icon>
  </div>
</div>
